import * as React from 'react'
import { useNavigate, useOutletContext, useParams } from 'react-router-dom'

import contractVersions from 'modules/contracts/store/collections/contractVersions'
import { isVisible } from 'modules/custom_resources/lib/utils'
import resources from 'modules/custom_resources/store/collections/customResources/resources'
import schemas from 'modules/custom_resources/store/collections/customResources/schemas'
import type Field from 'modules/custom_resources/store/models/customResources/Field'
import FormModal from 'modules/employees/components/CustomTables/FormModal'
import { RouteContext } from 'modules/employees/pages/CustomTablesListPage/context'
import type Employee from 'modules/employees/store/models/Employee'

export default function NewCustomTablePage() {
  const { schemaId } = useParams()

  const { employee, fields } = useOutletContext<{
    employee: Employee
    fields: Field[]
  }>()

  const rootRoute = React.useContext(RouteContext)
  const schema = schemas.get(Number(schemaId))

  const resource = resources.find({
    schema_id: schema?.attributes.id,
    attachable_type: 'Employee',
    attachable_id: employee.attributes.id,
  })

  const schemaFields = fields.filter(
    (f) =>
      f.get('schema_id') === schema?.attributes.id &&
      isVisible(employee, contractVersions)(f.attributes.visible)
  )

  const navigate = useNavigate()

  const onClose = () => {
    !!rootRoute && navigate(rootRoute.customTablesIndex())
  }

  return (
    <FormModal
      schema={schema}
      fields={schemaFields}
      resource={resource}
      attachableId={employee.attributes.id}
      attachableType="Employee"
      onClose={onClose}
    />
  )
}
